export class authconfiguration {
  uid: string;
  label: string;
  key: string;
  testURL: string;

}
